import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { MailCheck, AlertCircle, Loader2 } from 'lucide-react';
import { onboardingApi } from '../services/api';
import AfricaNendaLogo from '../components/AfricaNendaLogo';
import SupportContact from '../components/SupportContact';

const Shell = ({ children }) => (
  <div className="min-h-screen bg-gradient-to-br from-primary-50 to-blue-100 flex items-center justify-center p-4">
    <div className="max-w-md w-full bg-white rounded-xl shadow-xl p-8 text-center">
      <div className="flex justify-center mb-6"><AfricaNendaLogo className="h-8" /></div>
      {children}
    </div>
  </div>
);

export default function VerifyEmail() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState({ loading: true });

  useEffect(() => {
    if (!token) { setState({ loading: false, error: 'This verification link is missing its token.' }); return; }
    onboardingApi.verifyEmail(token)
      .then(() => setState({ loading: false, ok: true }))
      .catch(e => setState({ loading: false, error: e.response?.data?.error || e.message }));
  }, [token]);

  return (
    <Shell>
      {state.loading && <div className="py-6 text-gray-500 flex items-center justify-center gap-2"><Loader2 className="w-5 h-5 animate-spin" /> Verifying…</div>}
      {state.ok && (<>
        <div className="inline-flex w-14 h-14 bg-green-100 rounded-full items-center justify-center mb-4"><MailCheck className="w-7 h-7 text-green-600" /></div>
        <h1 className="text-lg font-semibold text-gray-900">Email verified</h1>
        <p className="text-sm text-gray-600 mt-2">Thanks — your application is now with AfricaNenda for review. We'll email you when there's a decision.</p>
      </>)}
      {state.error && (<>
        <div className="inline-flex w-14 h-14 bg-red-100 rounded-full items-center justify-center mb-4"><AlertCircle className="w-7 h-7 text-red-600" /></div>
        <h1 className="text-lg font-semibold text-gray-900">This link no longer works</h1>
        <p className="text-sm text-gray-600 mt-2">{state.error}</p>
        <p className="text-sm text-gray-600 mt-3">
          A verification link works once. If you have already verified your email, there is nothing more to do:
          follow your application with the "Track your application" link in the emails we sent you.
        </p>
        <SupportContact body className="mt-3" lead="Otherwise, email AfricaNenda at" subject="AfricaNenda IIPS Sandbox email verification link" />
        <p className="text-xs text-gray-500 mt-4">
          Never applied? <Link to="/register" className="text-primary-600 font-medium">Start an application</Link>
        </p>
      </>)}
      {!state.error && <SupportContact className="mt-6" subject="AfricaNenda IIPS Sandbox application" />}
    </Shell>
  );
}
